import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'antd-mobile'
import { FormattedMessage } from 'react-intl'
import { formatMoney } from '../../components/common/utils'

import styles from './PriceList.module.css'

const getSelectedGoodsList = (data, submitItems) => {
  const goodsListArr = []
  data.map((goodsList) => {
    goodsListArr.push(...goodsList.textbooksSaleListGoodsDTOS)
  })
  const selectedItemsList = submitItems.map((selectedItem) => {
    let selectedGood = goodsListArr.find(
      (item) => item.skuId === selectedItem.skuId && item.goodsId === selectedItem.goodsId
    )
    selectedGood = {
      ...selectedGood,
      number: selectedItem.number,
    }
    return selectedGood
  })
  return selectedItemsList
}

const getTotalPrice = (data, submitItems) => {
  const currency = data[0].textbooksSaleListGoodsDTOS[0].currencyType
  const selectedGoodsList = getSelectedGoodsList(data, submitItems)
  let total = 0
  for (let item of selectedGoodsList) {
    total += item.price * item.number
  }
  return formatMoney(total, currency, true)
}

const getTotalAmout = (data, submitItems) => {
  const selectedGoodsList = getSelectedGoodsList(data, submitItems)
  let amount = 0
  for (let item of selectedGoodsList) {
    amount += item.number
  }
  return amount
}

const CheckoutCounter = ({ priceListData, submitItems }) => {
  const history = useHistory()

  // 大陆(CNY)与海外(AUD/TWD)统一走本地下单结算页：后端 order() 按币种自动返回
  // paymentMethodType（大陆=FUIOU），BooksCheckout 的在线支付分支据此跳转富友/Stripe/TradeVan。
  const toCheckout = () => {
    history.push('/books_checkout', { priceList: priceListData, items: submitItems })
  }
  return (
    <div className={styles.checkout}>
      <div className={styles.price}>
        <div className={styles.checkout}>
          <span>
            <FormattedMessage id="book-total" />
            {getTotalPrice(priceListData, submitItems)}
          </span>
          <span className={styles.instructions}>
            <FormattedMessage id="book-checkout-hint" />
          </span>
        </div>
      </div>
      <div className={styles.pay}>
        <Button
          type="primary"
          className={styles.payBtn}
          disabled={!submitItems.length > 0 || !submitItems.every((item) => item.number)}
          onClick={toCheckout}
        >
          <FormattedMessage id="book-checkout" />({getTotalAmout(priceListData, submitItems)})
        </Button>
      </div>
    </div>
  )
}

export default CheckoutCounter
